let translator = (key) => key;

export const setTranslator = (t) => {
    translator = t;
};

export const translate = (key, options) => {
    try {
        return translator(key, options) || key;
    } catch {
        return key;
    }
};